// src/components/navigation-bar/navigation-bar.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment DateFragment on Date {\n    day\n    month\n    year\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n    uisPrimeMessages {\n      messageContent\n      schemaName\n    }\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment CarRentalLocationFragment on CarRentalLocation {\n    airportCode\n    coordinates {\n      latitude\n      longitude\n    }\n    isExactLocationSearch\n    regionId\n    searchTerm\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment DateTimeFragment on DateTime {\n    day\n    month\n    year\n    hour\n    minute\n    second\n  }\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment ActivitySaveItemFragment on TripsSaveItem {\n    initialChecked\n    itemId\n    source\n    attributes {\n      ...TripsSaveItemAttributesFragment\n    }\n    save {\n      ...TripsSaveItemPropertiesFragment\n    }\n    remove {\n      ...TripsSaveItemPropertiesFragment\n    }\n  }\n\n  fragment TripsSaveItemAttributesFragment on TripsSaveItemAttributes {\n    ...TripsSaveStayAttributesFragment\n    ...TripsSaveActivityAttributesFragment\n    ...TripsSaveFlightSearchAttributesFragment\n    ...TripsSaveCarOfferAttributesFragment\n  }\n\n  fragment TripsSaveStayAttributesFragment on TripsSaveStayAttributes {\n    checkInDate {\n      ...DateFragment\n    }\n    checkoutDate {\n      ...DateFragment\n    }\n    regionId\n    roomConfiguration {\n      numberOfAdults\n      childAges\n    }\n  }\n\n  fragment TripsSaveActivityAttributesFragment on TripsSaveActivityAttributes {\n    regionId\n    dateRange {\n      start {\n        ...DateFragment\n      }\n      end {\n        ...DateFragment\n      }\n    }\n  }\n\n  fragment TripsSaveItemPropertiesFragment on TripsSaveItemProperties {\n    accessibility\n    analytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    label\n  }\n\n  fragment TripsSaveFlightSearchAttributesFragment on TripsSaveFlightSearchAttributes {\n    searchCriteria {\n      primary {\n        journeyCriterias {\n          arrivalDate {\n            ...DateFragment\n          }\n          departureDate {\n            ...DateFragment\n          }\n          destination\n          destinationAirportLocationType\n          origin\n          originAirportLocationType\n        }\n        searchPreferences {\n          advancedFilters\n          airline\n          cabinClass\n        }\n        travelers {\n          age\n          type\n        }\n        tripType\n      }\n      secondary {\n        booleans {\n          id\n          value\n        }\n        counts {\n          id\n          value\n        }\n        dates {\n          id\n          value {\n            ...DateFragment\n          }\n        }\n        ranges {\n          id\n          min\n          max\n        }\n        selections {\n          id\n          value\n        }\n      }\n    }\n  }\n\n  fragment TripsSaveCarOfferAttributesFragment on TripsSaveCarOfferAttributes {\n    categoryCode\n    fuelAcCode\n    offerToken\n    searchCriteria {\n      dropOffDateTime {\n        ...DateTimeFragment\n      }\n      dropOffLocation {\n        ...CarRentalLocationFragment\n      }\n      pickUpDateTime {\n        ...DateTimeFragment\n      }\n      pickUpLocation {\n        ...CarRentalLocationFragment\n      }\n    }\n    transmissionDriveCode\n    typeCode\n    vendorCode\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment EGDSHeadingFragment on EGDSHeading {\n    text\n    headingType\n    accessibility\n  }\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment EGDSParagraphFragment on EGDSParagraph {\n    text\n    style\n  }\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n    title\n    withBackground\n  }\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment EGDSMarkFragment on Mark {\n    description\n    id\n    markSize: size\n    url {\n      ... on HttpURI {\n        __typename\n        relativePath\n        value\n      }\n    }\n  }\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment EGDSGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...EGDSIconFragment\n    }\n\n    ... on Mark {\n      ...EGDSMarkFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n        ... on HttpURI {\n          relativePath\n        }\n      }\n      target\n      useRelativePath\n    }\n    disabled\n    standardLinkIcon: icon {\n      ...EGDSIconFragment\n    }\n    iconPosition\n    size\n    text\n  }\n\n  ", "\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment EGDSGraphicTextFragment on EGDSGraphicText {\n    graphic {\n      ...EGDSGraphicFragment\n    }\n    text\n  }\n\n  ", "\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment EGDSIconTextFragment on EGDSIconText {\n    icon {\n      ...EGDSIconFragment\n    }\n    text\n  }\n\n  ", "\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  fragment EGDSInlineLinkFragment on EGDSInlineLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n      target\n    }\n    disabled\n    size\n    text\n  }\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject14() {
  var data = _tagged_template_literal(["\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"]);
  _templateObject14 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject15() {
  var data = _tagged_template_literal(["\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    text\n    theme\n    weight\n    accessibility\n    decorative\n  }\n"]);
  _templateObject15 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject16() {
  var data = _tagged_template_literal(["\n  fragment EGDSSpannableTextContentFragment on EGDSText {\n    ...EGDSStylizedTextFragment\n    ...EGDSGraphicTextFragment\n    ...EGDSPlainTextFragment\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject16 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject17() {
  var data = _tagged_template_literal(["\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    text\n    contents {\n      ...EGDSSpannableTextContentFragment\n    }\n    inlineContent {\n      ...EGDSSpannableTextContentFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject17 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject18() {
  var data = _tagged_template_literal(["\n  fragment EGDSTextFragment on EGDSText {\n    ...EGDSHeadingFragment\n    ...EGDSPlainTextFragment\n    ...EGDSStylizedTextFragment\n    ...EGDSIconTextFragment\n    ...EGDSGraphicTextFragment\n    ...EGDSParagraphFragment\n    ...EGDSStandardLinkFragment\n    ...EGDSInlineLinkFragment\n    ...EGDSSpannableTextFragment\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject18 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject19() {
  var data = _tagged_template_literal(["\n  fragment ActivityCopyLinkActionFragment on ActivityCopyLinkAction {\n    toast {\n      text\n    }\n    value\n  }\n"]);
  _templateObject19 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject20() {
  var data = _tagged_template_literal(["\n  fragment ActivityEmailActionFragment on ActivityEmailAction {\n    mailBody\n    mailSubject\n  }\n"]);
  _templateObject20 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject21() {
  var data = _tagged_template_literal(["\n  fragment ActivitySMSActionFragment on ActivitySMSAction {\n    smsBody\n  }\n"]);
  _templateObject21 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject22() {
  var data = _tagged_template_literal(["\n  fragment ActivityNavigationBarClickActionFragment on ActivityNavigationBarClickAction {\n    ...ActivityEmailActionFragment\n    ...ActivitySMSActionFragment\n    ...ActivityCopyLinkActionFragment\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject22 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject23() {
  var data = _tagged_template_literal(["\n  fragment ActivitySubMenuItemFragment on ActivitySubMenuItem {\n    analytics {\n      referrerId\n      linkName\n    }\n    title\n    icon {\n      id\n    }\n    action {\n      ...ActivityNavigationBarClickActionFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject23 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject24() {
  var data = _tagged_template_literal(["\n  fragment EGDSMenuListItemFragment on EGDSMenuListItem {\n    ...ActivitySubMenuItemFragment\n  }\n\n  ", "\n"]);
  _templateObject24 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject25() {
  var data = _tagged_template_literal(["\n  fragment ActivitySubMenuFragment on ActivitySubMenu {\n    items {\n      ...EGDSMenuListItemFragment\n    }\n    title\n  }\n\n  ", "\n"]);
  _templateObject25 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject26() {
  var data = _tagged_template_literal(["\n  fragment EGDSSubMenuFragment on EGDSSubMenu {\n    ...ActivitySubMenuFragment\n  }\n\n  ", "\n"]);
  _templateObject26 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject27() {
  var data = _tagged_template_literal(["\n  fragment EGDSGraphicMenuFragment on EGDSGraphicMenu {\n    analytics {\n      referrerId\n      linkName\n    }\n    title\n    subMenus {\n      ...EGDSSubMenuFragment\n    }\n    graphic {\n      ...EGDSGraphicFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject27 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject28() {
  var data = _tagged_template_literal(["\n  fragment EGDSMenuFragment on EGDSMenu {\n    ...EGDSGraphicMenuFragment\n  }\n\n  ", "\n"]);
  _templateObject28 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject29() {
  var data = _tagged_template_literal(["\n  query ActivityNavigationBarQuery(\n    $context: ContextInput!\n    $activityId: String!\n    $dateRange: ActivityDateRangeInput\n    $destination: ActivityDestinationInput\n    $searchFilters: ActivitySearchFiltersInput\n  ) {\n    activityInfo(context: $context, activityId: $activityId, dateRange: $dateRange, destination: $destination) {\n      navigationBar(searchFilters: $searchFilters) {\n        primary\n        backLink {\n          ...EGDSStandardLinkFragment\n        }\n        shareMenu {\n          ...EGDSMenuFragment\n        }\n        saveItem {\n          ...ActivitySaveItemFragment\n        }\n      }\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject29 = function _templateObject() {
    return data;
  };
  return data;
}
import React20 from "react";
import { gql as gql30, useQuery } from "@apollo/client";
// ../internal/src/components/activity-trip-save-item/activity-trips-save-item.tsx
import React from "react";
import { gql as gql5 } from "@apollo/client";
import { buildStateProvider } from "@shared-ui/provided-state-context";
import { Source, TripSaveItem, ValidatedInputsState } from "@shared-ui/trips-save-item";
// ../internal/src/__fragments/common/date-fragment.ts
import { gql } from "@apollo/client";
var __DateFragment = gql(_templateObject());
// ../internal/src/__fragments/common/client-side-analytics.ts
import { gql as gql2 } from "@apollo/client";
var clientSideAnalyticsFragment = gql2(_templateObject1());
// ../internal/src/__fragments/common/car-rental-location.ts
import { gql as gql3 } from "@apollo/client";
var __CarRentalLocation = gql3(_templateObject2());
// ../internal/src/__fragments/common/date-time.ts
import { gql as gql4 } from "@apollo/client";
var __DateTime = gql4(_templateObject3());
// ../internal/src/components/activity-trip-save-item/activity-trips-save-item.tsx
var __Fragment = gql5(_templateObject4(), __DateTime, __CarRentalLocation, __DateFragment);
var ValidatedInputsStateProvider = buildStateProvider(new ValidatedInputsState());
var ActivitySaveItem = function (param) {
  var data = param.data,
    heartLayoutPosition = param.heartLayoutPosition;
  var _data_attributes;
  switch ((_data_attributes = data.attributes) === null || _data_attributes === void 0 ? void 0 : _data_attributes.__typename) {
    case "TripsSaveActivityAttributes":
      {
        return /* @__PURE__ */React.createElement(ValidatedInputsStateProvider, null, /* @__PURE__ */React.createElement(TripSaveItem, {
          data: data,
          source: Source.ACTIVITY_DETAILS,
          heartLayoutPosition: heartLayoutPosition
        }));
      }
    default:
      return null;
  }
};
ActivitySaveItem.displayName = "ActivitySaveItem";
ActivitySaveItem.fragment = __Fragment;
// ../internal/src/components/egds-text/egds-heading.tsx
import React2 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkHeading } from "uitk-react-text";
var _obj;
// ../internal/src/components/egds-text/__private/heading-map.ts
var headingTagMapper = (_obj = {}, _define_property(_obj, "H1" /* H1 */, "h1"), _define_property(_obj, "H2" /* H2 */, "h2"), _define_property(_obj, "H3" /* H3 */, "h3"), _define_property(_obj, "H4" /* H4 */, "h4"), _define_property(_obj, "H5" /* H5 */, "h5"), _define_property(_obj, "H6" /* H6 */, "h6"), _define_property(_obj, "H7" /* H7 */, "h6"), _define_property(_obj, "H8" /* H8 */, "h6"), _obj);
// ../internal/src/components/egds-text/egds-heading.tsx
var fragment = gql6(_templateObject5());
var EGDSHeading = function (param) {
  var className = param.className,
    align = param.align,
    size = param.size,
    tag = param.tag,
    data = param.data,
    tabIndex = param.tabIndex;
  var headingType = data.headingType,
    text = data.text,
    accessibility = data.accessibility;
  var headingTag = tag !== null && tag !== void 0 ? tag : headingType ? headingTagMapper[headingType] : void 0;
  return /* @__PURE__ */React2.createElement(React2.Fragment, null, /* @__PURE__ */React2.createElement(UitkHeading, {
    className: className,
    align: align,
    tag: tag !== null && tag !== void 0 ? tag : headingTag,
    size: size,
    tabIndex: tabIndex,
    "aria-hidden": accessibility !== null
  }, text), accessibility && /* @__PURE__ */React2.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility));
};
EGDSHeading.fragment = fragment;
EGDSHeading.displayName = "EGDSHeading";
// ../internal/src/components/egds-text/egds-paragraph.tsx
import React3 from "react";
import { gql as gql7 } from "@apollo/client";
import { UitkParagraph } from "uitk-react-text";
var _obj1;
// ../internal/src/components/egds-text/__private/paragraph-style-size-map.ts
var paragraphStyleSizeMap = (_obj1 = {}, _define_property(_obj1, "P1" /* P1 */, 1), _define_property(_obj1, "P2" /* P2 */, 2), _define_property(_obj1, "P3" /* P3 */, 3), _obj1);
// ../internal/src/components/egds-text/egds-paragraph.tsx
var fragment2 = gql7(_templateObject6());
var EGDSParagraph = function (param) {
  var className = param.className,
    data = param.data;
  var text = data.text,
    style = data.style;
  return /* @__PURE__ */React3.createElement(UitkParagraph, {
    className: className,
    size: paragraphStyleSizeMap[style]
  }, text);
};
EGDSParagraph.fragment = fragment2;
EGDSParagraph.displayName = "EGDSParagraph";
// ../internal/src/components/egds-text/egds-standard-link.tsx
import React7 from "react";
import { gql as gql11 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkLink } from "uitk-react-link";
import { UitkText } from "uitk-react-text";
// ../internal/src/components/egds-graphic/egds-icon.tsx
import React4 from "react";
import { gql as gql8 } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
var __EGDSIconFragment = gql8(_templateObject7());
var _data_title, _data_theme;
var EGDSIcon = function (param) {
  var className = param.className,
    data = param.data;
  var _data;
  return /* @__PURE__ */React4.createElement(UitkIcon, {
    className: className,
    description: data.description,
    id: Math.random().toString(),
    name: data.id,
    size: data.size ? UitkIconSize[data.size] : void 0,
    title: (_data_title = data.title) !== null && _data_title !== void 0 ? _data_title : void 0,
    theme: (_data_theme = (_data = data) === null || _data === void 0 ? void 0 : _data.theme) !== null && _data_theme !== void 0 ? _data_theme : void 0,
    shadow: Boolean(data.withBackground)
  });
};
EGDSIcon.displayName = "EGDSIcon";
EGDSIcon.fragment = __EGDSIconFragment;
// ../internal/src/components/egds-graphic/egds-mark.tsx
import React5 from "react";
import { gql as gql9 } from "@apollo/client";
import { UitkMark, UitkMarkSize } from "uitk-react-mark";
var __EGDSMarkFragment = gql9(_templateObject8());
var EGDSMark = function (param) {
  var className = param.className,
    data = param.data;
  var _data_url;
  return /* @__PURE__ */React5.createElement(UitkMark, {
    className: className,
    description: data.description,
    id: data.id,
    name: data.id,
    size: data.markSize ? UitkMarkSize[data.markSize] : void 0,
    url: (_data_url = data.url) === null || _data_url === void 0 ? void 0 : _data_url.value
  });
};
EGDSMark.displayName = "EGDSMark";
EGDSMark.fragment = __EGDSMarkFragment;
// ../internal/src/components/egds-graphic/egds-graphic.tsx
import React6 from "react";
import { gql as gql10 } from "@apollo/client";
var __EGDSGraphicFragment = gql10(_templateObject9(), EGDSIcon.fragment, EGDSMark.fragment);
var EGDSGraphic = function (param) {
  var className = param.className,
    data = param.data;
  switch (data.__typename) {
    case "Icon":
      return /* @__PURE__ */React6.createElement(EGDSIcon, {
        className: className,
        data: data
      });
    case "Mark":
      return /* @__PURE__ */React6.createElement(EGDSMark, {
        className: className,
        data: data
      });
    default:
      return null;
  }
};
EGDSGraphic.displayName = "EGDSGraphic";
EGDSGraphic.fragment = __EGDSGraphicFragment;
var _obj2;
// ../internal/src/components/egds-text/__private/link-map.ts
var linkSizeMapper = (_obj2 = {}, _define_property(_obj2, "SMALL" /* SMALL */, "small"), _define_property(_obj2, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj2, "LARGE" /* LARGE */, "large"), _obj2);
var _obj3;
var UILinkTargetMap = (_obj3 = {}, _define_property(_obj3, "EXTERNAL" /* EXTERNAL */, "_blank"), _define_property(_obj3, "INTERNAL" /* INTERNAL */, "_self"), _obj3);
// ../internal/src/components/egds-text/egds-standard-link.tsx
var fragment3 = gql11(_templateObject10(), EGDSIcon.fragment);
var IconPlacement = function (param) {
  var icon = param.icon,
    iconPosition = param.iconPosition,
    iconPositionToMatch = param.iconPositionToMatch;
  if (icon && iconPosition === iconPositionToMatch) {
    return /* @__PURE__ */React7.createElement(EGDSIcon, {
      data: icon
    });
  }
  return null;
};
var EGDSStandardLink = function (param) {
  var className = param.className,
    inline = param.inline,
    align = param.align,
    _param_data = param.data,
    _param_data_action = _param_data.action,
    analytics = _param_data_action.analytics,
    resource = _param_data_action.resource,
    target = _param_data_action.target,
    accessibility = _param_data_action.accessibility,
    useRelativePath = _param_data_action.useRelativePath,
    disabled = _param_data.disabled,
    iconPosition = _param_data.iconPosition,
    standardLinkIcon = _param_data.standardLinkIcon,
    size = _param_data.size,
    text = _param_data.text;
  var clickTracker = useClickTracker();
  var onClick = React7.useCallback(function () {
    clickTracker(analytics.referrerId, analytics.linkName);
  }, [clickTracker, analytics]);
  var getPath = React7.useCallback(function () {
    switch (resource.__typename) {
      case "HttpURI":
        return useRelativePath ? resource.relativePath : resource.value;
      default:
        return resource.value;
    }
  }, [resource, useRelativePath]);
  return /* @__PURE__ */React7.createElement(UitkLink, {
    className: className,
    size: linkSizeMapper[size],
    onClickCapture: onClick,
    inline: inline,
    disabled: disabled,
    align: align
  }, /* @__PURE__ */React7.createElement("a", {
    target: UILinkTargetMap[target],
    href: getPath()
  }, /* @__PURE__ */React7.createElement(IconPlacement, {
    icon: standardLinkIcon,
    iconPosition: iconPosition,
    iconPositionToMatch: "LEADING" /* LEADING */
  }), text, /* @__PURE__ */React7.createElement(IconPlacement, {
    icon: standardLinkIcon,
    iconPosition: iconPosition,
    iconPositionToMatch: "TRAILING" /* TRAILING */
  }), accessibility && /* @__PURE__ */React7.createElement(UitkText, {
    className: "is-visually-hidden"
  }, accessibility)));
};
EGDSStandardLink.fragment = fragment3;
EGDSStandardLink.displayName = "EGDSStandardLink";
// ../internal/src/components/egds-text/egds-text.tsx
import React15 from "react";
import { gql as gql19 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-graphic-text.tsx
import React8 from "react";
import { gql as gql12 } from "@apollo/client";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText as UitkText2 } from "uitk-react-text";
var fragment4 = gql12(_templateObject11(), EGDSGraphic.fragment);
var graphicMargin = {
  inlineend: "one"
};
var textMargin = {
  inlineend: "one"
};
var EGDSGraphicText = function (param) {
  var className = param.className,
    size = param.size,
    data = param.data;
  var graphic = data.graphic,
    text = data.text;
  return /* @__PURE__ */React8.createElement(UitkLayoutFlex, {
    className: className
  }, /* @__PURE__ */React8.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React8.createElement(UitkSpacing, {
    margin: graphicMargin
  }, /* @__PURE__ */React8.createElement(EGDSGraphic, {
    data: graphic
  }))), /* @__PURE__ */React8.createElement(UitkLayoutFlexItem, {
    alignSelf: "center"
  }, /* @__PURE__ */React8.createElement(UitkSpacing, {
    margin: textMargin
  }, /* @__PURE__ */React8.createElement(UitkText2, {
    size: size
  }, text))));
};
EGDSGraphicText.fragment = fragment4;
EGDSGraphicText.displayName = "EGDSGraphicText";
// ../internal/src/components/egds-text/egds-icon-text.tsx
import React9 from "react";
import { gql as gql13 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkText as UitkText3 } from "uitk-react-text";
var fragment5 = gql13(_templateObject12(), EGDSIcon.fragment);
var iconMargin = {
  inlineend: "one"
};
var textMargin2 = {
  inlineend: "one"
};
var EGDSIconText = function (param) {
  var className = param.className,
    size = param.size,
    data = param.data;
  var icon = data.icon,
    text = data.text;
  return /* @__PURE__ */React9.createElement(UitkLayoutFlex2, {
    className: className
  }, /* @__PURE__ */React9.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */React9.createElement(UitkSpacing2, {
    margin: iconMargin
  }, /* @__PURE__ */React9.createElement(EGDSIcon, {
    data: icon
  }))), /* @__PURE__ */React9.createElement(UitkLayoutFlexItem2, {
    alignSelf: "center"
  }, /* @__PURE__ */React9.createElement(UitkSpacing2, {
    margin: textMargin2
  }, /* @__PURE__ */React9.createElement(UitkText3, {
    size: size
  }, text))));
};
EGDSIconText.fragment = fragment5;
EGDSIconText.displayName = "EGDSIconText";
// ../internal/src/components/egds-text/egds-inline-link.tsx
import React10 from "react";
import { gql as gql14 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink as UitkLink2 } from "uitk-react-link";
var fragment6 = gql14(_templateObject13());
var EGDSInlineLink = function (param) {
  var className = param.className,
    _param_data = param.data,
    _param_data_action = _param_data.action,
    analytics = _param_data_action.analytics,
    resource = _param_data_action.resource,
    target = _param_data_action.target,
    accessibility = _param_data_action.accessibility,
    disabled = _param_data.disabled,
    size = _param_data.size,
    text = _param_data.text;
  var clickTracker = useClickTracker2();
  var onClick = React10.useCallback(function () {
    clickTracker(analytics.referrerId, analytics.linkName);
  }, [clickTracker, analytics]);
  return /* @__PURE__ */React10.createElement(UitkLink2, {
    className: className,
    size: linkSizeMapper[size],
    onClickCapture: onClick,
    disabled: disabled,
    inline: true
  }, /* @__PURE__ */React10.createElement("a", {
    href: resource.value,
    target: UILinkTargetMap[target]
  }, text, accessibility && /* @__PURE__ */React10.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility)));
};
EGDSInlineLink.fragment = fragment6;
EGDSInlineLink.displayName = "EGDSInlineLink";
// ../internal/src/components/egds-text/egds-plain-text.tsx
import React11 from "react";
import { gql as gql15 } from "@apollo/client";
import { UitkText as UitkText4 } from "uitk-react-text";
var fragment7 = gql15(_templateObject14());
var EGDSPlainText = function (param) {
  var className = param.className,
    inline = param.inline,
    align = param.align,
    size = param.size,
    theme = param.theme,
    data = param.data;
  var text = data.text;
  return /* @__PURE__ */React11.createElement(UitkText4, {
    whiteSpace: "pre-line",
    className: className,
    align: align,
    size: size,
    inline: inline,
    theme: theme
  }, text);
};
EGDSPlainText.fragment = fragment7;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
import React14 from "react";
import { gql as gql18 } from "@apollo/client";
import { UitkText as UitkText6 } from "uitk-react-text";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-content.tsx
import React13 from "react";
import { gql as gql17 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React12 from "react";
import { gql as gql16 } from "@apollo/client";
import { UitkText as UitkText5 } from "uitk-react-text";
var _obj4;
// ../internal/src/components/egds-text/__private/text-theme.ts
var textThemeMapper = (_obj4 = {}, _define_property(_obj4, "EMPHASIS" /* EMPHASIS */, "emphasis"), _define_property(_obj4, "NEGATIVE" /* NEGATIVE */, "negative"), _define_property(_obj4, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj4, "PRIMARY" /* PRIMARY */, "emphasis"), _define_property(_obj4, "SECONDARY" /* SECONDARY */, "default"), _define_property(_obj4, "LOYALTY" /* LOYALTY */, "loyalty"), _define_property(_obj4, "INVERSE" /* INVERSE */, "inverse"), _define_property(_obj4, "EMPHASIS" /* EMPHASIS */, "emphasis"), _obj4);
var _obj5;
var UitkTextThemeMapper = (_obj5 = {}, _define_property(_obj5, "NEGATIVE" /* NEGATIVE */, "negative"), _define_property(_obj5, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj5, "EMPHASIS" /* EMPHASIS */, "emphasis"), _define_property(_obj5, "LOYALTY" /* LOYALTY */, "loyalty"), _define_property(_obj5, "DEFAULT" /* DEFAULT */, "default"), _obj5);
var _obj6;
// ../internal/src/components/egds-text/__private/text-weight.ts
var textWeightMapper = (_obj6 = {}, _define_property(_obj6, "BOLD" /* BOLD */, "bold"), _define_property(_obj6, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj6, "REGULAR" /* REGULAR */, "regular"), _obj6);
// ../internal/src/components/egds-text/egds-stylized-text.tsx
var fragment8 = gql16(_templateObject15());
var EGDSStylizedText = function (param) {
  var className = param.className,
    inline = param.inline,
    align = param.align,
    size = param.size,
    data = param.data;
  var text = data.text,
    theme = data.theme,
    weight = data.weight,
    accessibility = data.accessibility,
    decorative = data.decorative;
  var themeProps = theme ? textThemeMapper[theme] : void 0;
  var weightProps = weight ? textWeightMapper[weight] : void 0;
  var RenderText = function () {
    return /* @__PURE__ */React12.createElement(React12.Fragment, null, /* @__PURE__ */React12.createElement(UitkText5, {
      className: className,
      align: align,
      inline: inline,
      size: size,
      theme: themeProps,
      weight: weightProps,
      "aria-hidden": accessibility !== null
    }, text), accessibility && /* @__PURE__ */React12.createElement("span", {
      className: "is-visually-hidden"
    }, accessibility));
  };
  switch (decorative) {
    case "LINE_THROUGH" /* LINE_THROUGH */:
      return /* @__PURE__ */React12.createElement("s", null, /* @__PURE__ */React12.createElement(RenderText, null));
    default:
      return /* @__PURE__ */React12.createElement(RenderText, null);
  }
};
EGDSStylizedText.fragment = fragment8;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-content.tsx
var fragment9 = gql17(_templateObject16(), EGDSStylizedText.fragment, EGDSGraphicText.fragment, EGDSPlainText.fragment);
var EGDSSpannableTextContent = function (param) {
  var className = param.className,
    size = param.size,
    align = param.align,
    theme = param.theme,
    data = param.data;
  switch (data.__typename) {
    case "EGDSStylizedText":
      return /* @__PURE__ */React13.createElement(EGDSStylizedText, {
        className: className,
        data: data,
        size: size,
        inline: true
      });
    case "EGDSGraphicText":
      return /* @__PURE__ */React13.createElement(EGDSGraphicText, {
        className: className,
        data: data,
        size: size
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React13.createElement(EGDSPlainText, {
        className: className,
        data: data,
        size: size,
        align: align,
        inline: true,
        theme: theme
      });
    default:
      return null;
  }
};
EGDSSpannableTextContent.fragment = fragment9;
EGDSSpannableTextContent.displayName = "EGDSSpannableTextContent";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
var fragment10 = gql18(_templateObject17(), EGDSSpannableTextContent.fragment);
var EGDSSpannableText = function (props) {
  var _data_contents, _data, _data_inlineContent, _data1, _data_inlineContent1, _data2;
  var align = props.align,
    headingSize = props.headingSize,
    data = props.data,
    theme = props.theme,
    styleProps = _object_without_properties(props, ["align", "headingSize", "data", "theme"]);
  if (((_data = data) === null || _data === void 0 ? void 0 : (_data_contents = _data.contents) === null || _data_contents === void 0 ? void 0 : _data_contents.length) === 0 && !((_data1 = data) === null || _data1 === void 0 ? void 0 : (_data_inlineContent = _data1.inlineContent) === null || _data_inlineContent === void 0 ? void 0 : _data_inlineContent.length)) {
    return /* @__PURE__ */React14.createElement(UitkText6, _object_spread_props(_object_spread({}, styleProps), {
      inline: true,
      align: align,
      theme: theme
    }), data.text);
  }
  if ((_data2 = data) === null || _data2 === void 0 ? void 0 : (_data_inlineContent1 = _data2.inlineContent) === null || _data_inlineContent1 === void 0 ? void 0 : _data_inlineContent1.length) {
    return /* @__PURE__ */React14.createElement(React14.Fragment, null, data.inlineContent.map(function (item, index) {
      return /* @__PURE__ */React14.createElement(React14.Fragment, null, /* @__PURE__ */React14.createElement(EGDSSpannableTextContent, _object_spread_props(_object_spread({
        align: align,
        data: item
      }, styleProps), {
        key: "spannable-item-".concat(index),
        theme: theme
      })), " ");
    }));
  }
  return /* @__PURE__ */React14.createElement(React14.Fragment, null, data.contents.map(function (item, index) {
    return /* @__PURE__ */React14.createElement(React14.Fragment, {
      key: "spannable-item-".concat(index)
    }, /* @__PURE__ */React14.createElement(EGDSSpannableTextContent, _object_spread_props(_object_spread({
      data: item
    }, styleProps), {
      headingSize: headingSize,
      theme: theme
    })), " ");
  }));
};
EGDSSpannableText.fragment = fragment10;
EGDSSpannableText.displayName = "EGDSSpannableText";
// ../internal/src/components/egds-text/egds-text.tsx
var fragment11 = gql19(_templateObject18(), EGDSHeading.fragment, EGDSPlainText.fragment, EGDSStylizedText.fragment, EGDSIconText.fragment, EGDSGraphicText.fragment, EGDSParagraph.fragment, EGDSStandardLink.fragment, EGDSInlineLink.fragment, EGDSSpannableText.fragment);
var EGDSText = function (param) {
  var className = param.className,
    headingAlign = param.headingAlign,
    headingSize = param.headingSize,
    headingTag = param.headingTag,
    textAlign = param.textAlign,
    textSize = param.textSize,
    align = param.align,
    inline = param.inline,
    tabIndex = param.tabIndex,
    theme = param.theme,
    data = param.data;
  var _data;
  switch ((_data = data) === null || _data === void 0 ? void 0 : _data.__typename) {
    case "EGDSHeading":
      return /* @__PURE__ */React15.createElement(EGDSHeading, {
        className: className,
        align: headingAlign,
        size: headingSize,
        tag: headingTag,
        data: data,
        tabIndex: tabIndex
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React15.createElement(EGDSPlainText, {
        className: className,
        align: textAlign,
        size: textSize,
        data: data,
        inline: inline,
        theme: theme
      });
    case "EGDSStylizedText":
      return /* @__PURE__ */React15.createElement(EGDSStylizedText, {
        className: className,
        align: textAlign,
        size: textSize,
        data: data,
        inline: inline
      });
    case "EGDSGraphicText":
      return /* @__PURE__ */React15.createElement(EGDSGraphicText, {
        className: className,
        size: textSize,
        data: data
      });
    case "EGDSIconText":
      return /* @__PURE__ */React15.createElement(EGDSIconText, {
        className: className,
        size: textSize,
        data: data
      });
    case "EGDSParagraph":
      return /* @__PURE__ */React15.createElement(EGDSParagraph, {
        className: className,
        data: data
      });
    case "EGDSStandardLink":
      return /* @__PURE__ */React15.createElement(EGDSStandardLink, {
        className: className,
        data: data
      });
    case "EGDSInlineLink":
      return /* @__PURE__ */React15.createElement(EGDSInlineLink, {
        className: className,
        data: data
      });
    case "EGDSSpannableText":
      return /* @__PURE__ */React15.createElement(EGDSSpannableText, {
        className: className,
        size: textSize,
        headingSize: headingSize,
        data: data,
        align: align,
        theme: theme
      });
    default:
      return null;
  }
};
EGDSText.fragment = fragment11;
EGDSText.displayName = "EGDSText";
// src/components/navigation-bar/navigation-bar.tsx
import { useBexApi } from "@shared-ui/bex-api-context";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
// src/components/navigation-bar/__private/__fragments/egds-menu/egds-menu.tsx
import React19 from "react";
import { gql as gql29 } from "@apollo/client";
// src/components/navigation-bar/__private/__fragments/egds-menu/egds-graphic-menu.tsx
import React18 from "react";
import { gql as gql28 } from "@apollo/client";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { UitkTertiaryButton } from "uitk-react-button";
import { PositionType, UitkMenu, UitkMenuContainer, UitkMenuTrigger } from "uitk-react-menu";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkToast } from "uitk-react-toast";
// src/components/navigation-bar/__private/__fragments/egds-menu/egds-sub-menu.tsx
import React17 from "react";
import { gql as gql27 } from "@apollo/client";
// src/components/navigation-bar/__private/__fragments/egds-menu/activity-sub-menu.tsx
import React16 from "react";
import { gql as gql26 } from "@apollo/client";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { UitkMenuList } from "uitk-react-menu";
// src/components/navigation-bar/__private/__fragments/egds-menu/egds-menu-list-item.ts
import { gql as gql25 } from "@apollo/client";
// src/components/navigation-bar/__private/__fragments/egds-menu/activity-sub-menu-item.ts
import { gql as gql24 } from "@apollo/client";
// src/components/navigation-bar/__private/__fragments/activity-navigation-bar-click-action/activity-navigation-bar-click-action.ts
import { gql as gql23 } from "@apollo/client";
// src/components/navigation-bar/__private/__fragments/activity-navigation-bar-click-action/activity-copy-link-action.ts
import { gql as gql20 } from "@apollo/client";
var _ActivityCopyLinkActionFragment = gql20(_templateObject19());
var getActivityCopyLinkAction = function (data, showToastMessage) {
  var value = data.value,
    toast = data.toast;
  var onCopyClick = function () {
    if (toast) {
      showToastMessage(toast.text);
    }
    navigator.clipboard.writeText(value);
  };
  return {
    onClick: onCopyClick
  };
};
// src/components/navigation-bar/__private/__fragments/activity-navigation-bar-click-action/activity-email-action.ts
import { gql as gql21 } from "@apollo/client";
var _ActivityEmailActionFragment = gql21(_templateObject20());
var getActivityEmailAction = function (data) {
  return {
    href: "mailto:?&subject=".concat(data.mailSubject, " &body=").concat(data.mailBody),
    typeAnchor: true
  };
};
// src/components/navigation-bar/__private/__fragments/activity-navigation-bar-click-action/activity-sms-action.ts
import { gql as gql22 } from "@apollo/client";
var _ActivitySMSActionFragment = gql22(_templateObject21());
var getActivitySMSAction = function (data) {
  return {
    href: "sms:&body=".concat(data.smsBody),
    typeAnchor: true
  };
};
// src/components/navigation-bar/__private/__fragments/activity-navigation-bar-click-action/activity-navigation-bar-click-action.ts
var _ActivityNavigationBarClickActionFragment = gql23(_templateObject22(), _ActivityEmailActionFragment, _ActivitySMSActionFragment, _ActivityCopyLinkActionFragment);
var getClickAction = function (data, showToastMessage) {
  var _data;
  switch ((_data = data) === null || _data === void 0 ? void 0 : _data.__typename) {
    case "ActivityEmailAction":
      return getActivityEmailAction(data);
    case "ActivitySMSAction":
      return getActivitySMSAction(data);
    case "ActivityCopyLinkAction":
      return getActivityCopyLinkAction(data, showToastMessage);
    default:
      return {};
  }
};
// src/components/navigation-bar/__private/__fragments/egds-menu/activity-sub-menu-item.ts
var _ActivitySubMenuItemFragment = gql24(_templateObject23(), _ActivityNavigationBarClickActionFragment);
var getActivitySubMenuItem = function (data, showToastMessage, clickTracker) {
  var _analytics, _analytics1, _icon;
  var analytics = data.analytics,
    title = data.title,
    icon = data.icon,
    action = data.action;
  var _analytics_referrerId, _analytics_linkName;
  var itemAnalytics = {
    id: (_analytics_referrerId = (_analytics = analytics) === null || _analytics === void 0 ? void 0 : _analytics.referrerId) !== null && _analytics_referrerId !== void 0 ? _analytics_referrerId : "",
    description: (_analytics_linkName = (_analytics1 = analytics) === null || _analytics1 === void 0 ? void 0 : _analytics1.linkName) !== null && _analytics_linkName !== void 0 ? _analytics_linkName : "",
    callback: function (id, description) {
      return clickTracker(id, description);
    }
  };
  var itemData = _object_spread({
    analytics: itemAnalytics,
    label: title,
    attributes: {
      role: "menuitem",
      tabindex: 0
    },
    className: "uitk-list-item",
    icon: {
      name: (_icon = icon) === null || _icon === void 0 ? void 0 : _icon.id
    }
  }, getClickAction(action, showToastMessage));
  return itemData;
};
// src/components/navigation-bar/__private/__fragments/egds-menu/egds-menu-list-item.ts
var _EGDSMenuListItemFragment = gql25(_templateObject24(), _ActivitySubMenuItemFragment);
var getEGDSMenuListItems = function (data, showToastMessage, clickTracker) {
  switch (data.__typename) {
    case "ActivitySubMenuItem":
      return getActivitySubMenuItem(data, showToastMessage, clickTracker);
    default:
      return {};
  }
};
// src/components/navigation-bar/__private/__fragments/egds-menu/activity-sub-menu.tsx
var fragment12 = gql26(_templateObject25(), _EGDSMenuListItemFragment);
var ActivitySubMenu = function (param) {
  var data = param.data,
    showToastMessage = param.showToastMessage;
  var items = data.items,
    title = data.title;
  var clickTracker = useClickTracker3();
  var listItems = items.map(function (item) {
    return getEGDSMenuListItems(item, showToastMessage, clickTracker);
  });
  return /* @__PURE__ */React16.createElement(UitkMenuList, {
    items: listItems,
    title: title !== null && title !== void 0 ? title : ""
  });
};
ActivitySubMenu.fragment = fragment12;
ActivitySubMenu.displayName = "ActivitySubMenu";
// src/components/navigation-bar/__private/__fragments/egds-menu/egds-sub-menu.tsx
var fragment13 = gql27(_templateObject26(), ActivitySubMenu.fragment);
var EGDSSubMenu = function (param) {
  var data = param.data,
    showToastMessage = param.showToastMessage;
  switch (data.__typename) {
    case "ActivitySubMenu":
      return /* @__PURE__ */React17.createElement(ActivitySubMenu, {
        data: data,
        showToastMessage: showToastMessage
      });
    default:
      return null;
  }
};
EGDSSubMenu.fragment = fragment13;
EGDSSubMenu.displayName = "EGDSSubMenu";
// src/components/navigation-bar/__private/__fragments/egds-menu/egds-graphic-menu.tsx
var fragment14 = gql28(_templateObject27(), EGDSSubMenu.fragment, EGDSGraphic.fragment);
var graphicSpacing = {
  inlineend: "two"
};
var EGDSGraphicMenu = function (param) {
  var className = param.className,
    data = param.data;
  var analytics = data.analytics,
    title = data.title,
    subMenus = data.subMenus,
    graphic = data.graphic;
  var _React18_useState = _sliced_to_array(React18.useState(false), 2),
    isMenuOpen = _React18_useState[0],
    setIsMenuOpen = _React18_useState[1];
  var _React18_useState1 = _sliced_to_array(React18.useState(""), 2),
    toastMessage = _React18_useState1[0],
    setToastMessage = _React18_useState1[1];
  var _React18_useState2 = _sliced_to_array(React18.useState(false), 2),
    isToastVisible = _React18_useState2[0],
    setIsToastVisible = _React18_useState2[1];
  var clickTracker = useClickTracker4();
  var handleClick = React18.useCallback(function () {
    setIsMenuOpen(!isMenuOpen);
    if (analytics) {
      clickTracker(analytics.referrerId, analytics.linkName);
    }
  }, [isMenuOpen, clickTracker, analytics]);
  var onToastDismiss = React18.useCallback(function () {
    setToastMessage("");
    setIsToastVisible(!isToastVisible);
  }, [isToastVisible]);
  var showToastMessage = React18.useCallback(function (message) {
    setToastMessage(message);
    setIsToastVisible(!isToastVisible);
  }, [isToastVisible]);
  return /* @__PURE__ */React18.createElement(React18.Fragment, null, /* @__PURE__ */React18.createElement(UitkMenu, {
    id: "activity-share-menu",
    isOpen: isMenuOpen,
    onTriggerClick: handleClick,
    className: className
  }, /* @__PURE__ */React18.createElement(UitkMenuTrigger, null, /* @__PURE__ */React18.createElement(UitkTertiaryButton, null, /* @__PURE__ */React18.createElement(React18.Fragment, null, /* @__PURE__ */React18.createElement(UitkSpacing3, {
    margin: graphicSpacing
  }, /* @__PURE__ */React18.createElement(EGDSGraphic, {
    data: graphic
  })), title))), /* @__PURE__ */React18.createElement(UitkMenuContainer, {
    position: PositionType.RIGHT
  }, subMenus.map(function (item, index) {
    return /* @__PURE__ */React18.createElement(EGDSSubMenu, {
      key: "submenu-".concat(index),
      data: item,
      showToastMessage: showToastMessage
    });
  }))), /* @__PURE__ */React18.createElement(UitkToast, {
    show: isToastVisible,
    onDismiss: onToastDismiss
  }, toastMessage));
};
EGDSGraphicMenu.fragment = fragment14;
EGDSGraphicMenu.displayName = "EGDSGraphicMenu";
// src/components/navigation-bar/__private/__fragments/egds-menu/egds-menu.tsx
var fragment15 = gql29(_templateObject28(), EGDSGraphicMenu.fragment);
var EGDSMenu = function (param) {
  var className = param.className,
    data = param.data;
  switch (data.__typename) {
    case "EGDSGraphicMenu":
      return /* @__PURE__ */React19.createElement(EGDSGraphicMenu, {
        data: data,
        className: className
      });
    default:
      return null;
  }
};
EGDSMenu.fragment = fragment15;
EGDSMenu.displayName = "EGDSMenu";
// src/components/navigation-bar/navigation-bar.tsx
var __Query = gql30(_templateObject29(), EGDSStandardLink.fragment, EGDSMenu.fragment, ActivitySaveItem.fragment);
var NavigationBar = function (props) {
  var _data_activityInfo_navigationBar, _data, _data_activityInfo_navigationBar1, _data1, _data_activityInfo_navigationBar2, _data2;
  var inputs = props.inputs,
    skipSsr = props.skipSsr,
    className = props.className;
  var context = useBexApi().context;
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery = useQuery(__Query, {
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  var backLink = (_data = data) === null || _data === void 0 ? void 0 : (_data_activityInfo_navigationBar = _data.activityInfo.navigationBar) === null || _data_activityInfo_navigationBar === void 0 ? void 0 : _data_activityInfo_navigationBar.backLink;
  var shareMenu = (_data1 = data) === null || _data1 === void 0 ? void 0 : (_data_activityInfo_navigationBar1 = _data1.activityInfo.navigationBar) === null || _data_activityInfo_navigationBar1 === void 0 ? void 0 : _data_activityInfo_navigationBar1.shareMenu;
  var saveItem = (_data2 = data) === null || _data2 === void 0 ? void 0 : (_data_activityInfo_navigationBar2 = _data2.activityInfo.navigationBar) === null || _data_activityInfo_navigationBar2 === void 0 ? void 0 : _data_activityInfo_navigationBar2.saveItem;
  if (error || loading || !backLink) {
    return null;
  }
  return /* @__PURE__ */React20.createElement("div", {
    className: className
  }, /* @__PURE__ */React20.createElement(UitkLayoutFlex3, {
    alignItems: "center",
    justifyContent: "space-between"
  }, /* @__PURE__ */React20.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */React20.createElement(EGDSStandardLink, {
    data: backLink,
    inline: true
  })), /* @__PURE__ */React20.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */React20.createElement(UitkLayoutFlex3, null, shareMenu && /* @__PURE__ */React20.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */React20.createElement(EGDSMenu, {
    data: shareMenu,
    className: className
  })), saveItem && /* @__PURE__ */React20.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */React20.createElement(ActivitySaveItem, {
    data: saveItem
  }))))));
};
NavigationBar.displayName = "sharedui-NavigationBar";
export { NavigationBar };